import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {CurrentObjectContext} from '../current-object.context';
import {ObjectContentTabModule} from '../../object-content-tab/object-content-tab.module';

@Component({
    selector: 'app-object-page-v2-subpage',
    imports: [
        ObjectContentTabModule,
    ],
    templateUrl: './object-page-v2-subpage.component.html',
    styleUrl: './object-page-v2-subpage.component.scss'
})
export class ObjectPageV2SubpageComponent {
  // Injections
  private readonly currentObjectContext: CurrentObjectContext = inject(CurrentObjectContext);
  private readonly route: ActivatedRoute = inject(ActivatedRoute);

  constructor() {
    this.route.paramMap.subscribe(p => {
      this.currentObjectContext.setCurrentList(p.get("segment"))
    });

  }

  segment = toSignal(this.route.paramMap.pipe(map(p => p.get("segment"))))

  contentInfo = this.currentObjectContext.contentInfo

  onObjectRefresh(event: any) {
    this.currentObjectContext.objectRefresh(event)
  }

}
